module.exports = __webpack_public_path__ + "static/media/walletW.360c5b9f.svg";